var StringUtils = {
    compare: function(aString, bString) {
        if (aString != null && bString == null) {
            return -1;
        } else if (aString == null && bString != null) {
            return 1;
        } else if (aString == null && bString == null) {
            return 0;
        } else {
            return aString.localeCompare(bString);
        }
    }
}

export default StringUtils;